module.exports = __webpack_public_path__ + "media/components/country-flag/static/sn-580af0ed14c2611c74a8be3c37c97bda.svg";